import { datadogRum } from '@datadog/browser-rum';
const env = process.env.REACT_APP_ENV ?? 'dev';
const isProd = env === 'production' || env === 'prod';

export const ddRum = () => {
  datadogRum.init({
    applicationId: 'c060e39a-fe15-41c6-b580-158c4d290665',
    clientToken: 'pub5367c2844dea48390397f6cf72864575',
    site: 'us5.datadoghq.com',
    service: 'gojeddle',
    env: env,
    // Reduced sampling to minimize cost and network calls
    sessionSampleRate: isProd ? 10 : 100,
    sessionReplaySampleRate: isProd ? 2 : 20,
    trackUserInteractions: true,
    // Disabled resource tracking to prevent excessive calls
    // This was causing multiple requests per file upload/thumbnail
    trackResources: false,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    // Exclude file uploads and static assets from tracking
    excludedActivityUrls: [
      /uploadFileToServer/i,
      /\.(pdf|jpeg|jpg|png|gif|webp|svg|ico)(\?.*)?$/i,
      /googleapis\.com/i,
      /storage\.cloud\.google\.com/i,
    ],
    // Teacher Check tokens, gift codes, confirmation and phone-upload tokens
    // travel in URLs; RUM gets placeholders instead (utils/rumUrlScrub.js).
    // Teacher Loop build flag on only (those URLs exist only then; the phone
    // upload screen never starts RUM). Required behind the flag literal, so a
    // flag-off build drops it and sends exactly what it sent before
    // (utils/teacherLoopGate.js).
    ...(process.env.REACT_APP_TEACHER_LOOP === 'on'
      ? { beforeSend: require('./utils/rumUrlScrub').scrubRumEvent }
      : {}),
  });
};
